// extracted by mini-css-extract-plugin
export default {"delimeter":"HexWuSB___delimeter","recommendation":"jA2lGc8___recommendation","comment":"os0Xegi___comment"};